import * as React from 'react';

export const LongArrowIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg width={21} height={8} viewBox="0 0 21 8" fill="none" {...props}>
            <path d="M.646 3.646a.5.5 0 000 .708l3.182 3.182a.5.5 0 10.708-.708L1.707 4l2.829-2.828a.5.5 0 10-.708-.708L.646 3.646zM21 3.5H1v1h20v-1z" />
        </svg>
    );
};
